<template>
  <div class="first">
    <div class="header">
      <van-nav-bar>
        <template #left>
          <van-image
            width="2rem"
            height="2rem"
            :src="require('../../assets/img/btc.png')"
            @click="openside"
          />
        </template>
        <template #title>
          <van-search
            v-model="search"
            clearable
            shape="round"
            :placeholder="$t('home.search')"
          />
        </template>
      <!--  <template #right>
          <van-icon
            name="chat-o"
            :badge="msgcount"
            @click="$router.push('/trade/contact/list')"
            v-if="msgcount > 0"
          />
          <van-icon
            name="chat-o"
            @click="$router.push('/trade/contact/list')"
            v-else
          />
        </template> -->
      </van-nav-bar>
    </div>
    <div class="maincontent">
      <!-- 轮播图 -->
      <div class="swipe">
        <van-swipe
          class="first-swipe"
          :autoplay="3000"
        >
          <van-swipe-item>
            <img :src="require('../../assets/img/swipe.png')" />
          </van-swipe-item>
          <van-swipe-item>
            <img :src="require('../../assets/img/swipe1.png')" />
          </van-swipe-item>
          <van-swipe-item>
            <img :src="require('../../assets/img/swipe2.png')" />
          </van-swipe-item>
          <template #indicator>
            <span></span>
          </template>
        </van-swipe>
      </div>
      <!-- 通知栏 -->
      <van-notice-bar
        scrollable
        left-icon="volume-o"
        :text="lang === 'zh' ? indexData.notice[0] : indexData['notice_' + lang ][0]"
      />
      <!-- 三个产品 -->
      <div class="currency-information">
        <div
          class="information skiptranslate"
          v-for="item in product"
          :key="item.pid"
          @click="totrade(item.pid)"
        >
          <span style="color: black;">
            <b style="margin-right: 10px;">{{ item.product_title }}</b>
            <span :style="{ color: item.change > 0 ? '#85b480' : '#b34f59' }">{{ item.change }}%</span><br />
            <span style="color: rgb(179, 79, 89); font-size: 25px;"><b>{{ item.current }}</b></span>
          </span>
        </div>
      </div>
      <!-- 快捷买币 -->
      <van-row class="currency">
        <van-row
          class="currency-shopping"
          @click="$router.push('/assets/recharge')"
        >
          <van-col
            span="4"
            class="currency-shopping-image"
          >
            <van-image
              width="3rem"
              height="2.5rem"
              src="data:image/png;base64,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"
            />
          </van-col>
          <van-col
            span="16"
            class="currency-shopping-left"
          >
            <b>{{ $t('home.quickbuy') }}</b>
            <br />
            <span>{{ $t('home.quicktext') }}</span>
          </van-col>
          <van-col
            span="4"
            class="currency-shopping-image"
          >
            <div style="font-size: 22px; width: 1.2rem; height: 1.2rem; background-color: rgb(0, 78, 163); border-radius: 50%; display: flex; justify-content: center; align-items: center; color: white;">
              <img
                data-v-6c89363e=""
                src="data:image/png;base64,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"
                alt=""
                style="width: 10px; height: 10px;"
              />
            </div>
          </van-col>
        </van-row>
        <van-row
          class="currency-service"
          style="border-top: 1px solid rgb(243, 243, 243);"
        >
          <van-col
            span="8"
            class="currency-service-span"
            style="padding-right: 0.666667px;"
          >
            <div @click="toservice">
              <van-image
                width="2rem"
                height="2rem"
                :src="require('../../assets/img/kftb.png')"
              />
              <span>{{ $t('home.serverurl') }}</span>
            </div>
          </van-col>
          <van-col
            span="8"
            class="currency-service-span"
            style="padding-left: 0.333333px; padding-right: 0.333333px;"
          >
            <div @click="tocourse">
              <van-image
                width="2rem"
                height="2rem"
                :src="require('../../assets/img/help.png')"
              />
              <span>{{ $t('home.course') }}</span>
            </div>
          </van-col>
          <van-col
            span="8"
            class="currency-service-span"
            style="padding-left: 0.666667px; border-left: 1px solid rgb(243, 243, 243);"
          >
            <div @click="$router.push('/trade/contact/list')">
              <van-image
                width="2rem"
                height="2rem"
                :src="require('../../assets/img/kftb.png')"
              />
              <span>{{ $t('home.fund') }}</span>
            </div>
          </van-col>
        </van-row>
      </van-row>
      <!-- banner -->
      <van-row class="banner-image">
        <van-image :src="require('../../assets/img/hb-banner.png')" />
      </van-row>
      <!-- 产品列表 -->
      <van-row style="margin: 0px auto; background-color: white; width: 94%; border-radius: 10px 10px 0px 0px;">
        <van-row class="currency-title">
          <van-col span="8"><span>{{ $t('home.hq') }}</span></van-col>
          <van-col span="8"><span>{{ $t('home.price') }}</span></van-col>
          <van-col span="8"><span>{{ $t('home.updown') }}</span></van-col>
        </van-row>
        <van-row style="background-color: white; width: 94%; margin: 0px auto;">
          <ul>
            <van-row
              class="currency-Increase skiptranslate"
              v-for="item in product"
              :key="item.id"
            >
              <van-col span="8"><span>{{ item.product_title }}</span></van-col>
              <van-col span="8"><span style="color:black"><b>{{ item.current }}</b></span></van-col>
              <van-col span="8">
                <van-button
                  class="currency-btn"
                  :style="{
                    backgroundColor: item.change > 0 ? '#85B480' : '#B34F59'
                  }"
                  @click="totrade(item.pid)"
                >
                  {{ item.change }}%
                </van-button>
              </van-col>
            </van-row>
            <van-row style="margin:20px">
              <span>{{ $t('common.nomore') }}</span>
            </van-row>
          </ul>
        </van-row>
      </van-row>
      <!-- 弹出层 -->
      <van-popup
        v-model="popshow"
        position="left"
        style="height:100%; width:80%"
      >
        <!-- 头部 -->
        <van-row class="personage-head">
          <van-row class="personage-head-image">
            <van-image
              width="5rem"
              height="5rem"
              :src="require('../../assets/img/btc.png')"
            />
          </van-row>
          <van-row class="personage-head-span">
            <van-row @click="tosetting">
              <b v-if="user.nickname">{{ user.nickname }}</b>
              <b v-else>{{ $t('home.nickname') }}</b>
            </van-row>
            <van-row>
              <span>UID:{{ user.username }}</span>
            </van-row>
          </van-row>
        </van-row>
        <!-- vip -->
        <van-row class="personage-member">
          <van-row
            class="personage-member-a"
            @click="toservice"
          >
            <van-col
              span="5"
              style="margin-top: 5px;"
            >
              <van-image
                width="3rem"
                height="2.5rem"
                :src="require('../../assets/img/vip.png')"
              />
            </van-col>
            <van-col span="13"><span style="font-size: 15px; color: rgb(146, 116, 47);">{{
                $t('home.vip')
              }}</span></van-col>
            <van-col>
              <van-image
                width="3rem"
                height="2rem"
                style="width: 0.8rem; height: 1.5rem; margin-top: 3px;"
                :src="require('../../assets/img/vip-1.png')"
              />
            </van-col>
          </van-row>
        </van-row>
        <!-- 列表 -->
        <van-row>
          <van-cell
            icon="user-circle-o"
            :title="$t('home.sf_auth')"
            is-link
            to="/person/authentication"
          />
          <van-cell
            icon="smile-comment-o"
            :title="$t('home.gj_auth')"
            is-link
            to="/person/authentication"
          />
          <van-cell
            icon="service-o"
            :title="$t('home.serverurl')"
            is-link
            :url="serverurl"
          />
          <van-cell
            icon="question-o"
            :title="$t('home.help')"
            is-link
            to="/course"
          />
          <van-cell
            icon="setting-o"
            :title="$t('home.set')"
            is-link
            to="/person/setting"
          />
        </van-row>
        <!-- 切换语言 -->
        <!-- <van-row
          class="personage-cut"
        > -->
          <!-- <span> {{ $t('home.change') }} </span>
          <i
            class="van-icon van-icon-arrow"
            style="margin-left: 5px; color: rgb(0, 78, 163);"
          ></i> -->
        <!-- </van-row> -->
        <van-dropdown-menu direction='up'>
            <van-dropdown-item :title="$t('qie-huan-yu-yan')" v-model="selectLang" :options="selectLangOption" @change="selectLangChange" />
        </van-dropdown-menu>
        <!-- 退出登录 -->
        <van-row
          class="personage-button"
          @click="logout"
        ><b>{{ $t('home.logout') }}</b></van-row>
      </van-popup>
      <van-popup
        v-model="suiji"
        position="center"
        :close-on-click-overlay="false"
        style="width:80%;border-radius:8px; font-size:16px"
      >
        <h3 style="line-height:40px">{{$t('editpass.title')}}</h3>
        <van-cell-group>
          <van-field
            v-model="editpass.oldpass"
            center
            clearable
            type="password"
            :placeholder="$t('register.enterpassword')"
          />
          <van-field
            v-model="editpass.newpass"
            center
            clearable
            type="password"
            :placeholder="$t('qing-shu-ru-xin-mi-ma')"
          />
          <van-field
            v-model="editpass.newpass2"
            center
            clearable
            type="password"
            :placeholder="$t('qing-shu-ru-xin-mi-ma')"
          />
        </van-cell-group>
        <van-button
          style="width:100%"
          @click="passsubmit"
        >{{$t('common.confirm')}}</van-button>
      </van-popup>
    </div>
    <audio
      controls
      ref="notify"
      style="display:none"
    >
      <source src="msg.mp3" />
    </audio>
<!--    <van-notify //消息提示
      v-model="notifyshow"
      @click.native="$router.push('/trade/contact/list')">
      <span>{{$t('ni-you') }}{{ msgcount }}{{ $t('tiao-xin-xiao-xi') }}</span>
      <van-icon
        name="cross"
        style="position:absolute;right:1rem;"
        @click.stop="closenotify"
      />
    </van-notify> -->
  </div>
</template>
<script>
function setCookie(cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + '; ' + expires
}
setCookie('googtrans', '/auto/en', 100)
export default {
  data() {
    return {
      selectLang: '',
      selectLangOption: [
        { text: '中文', value: 'zh' },
        { text: 'English', value: 'en' },
        { text: 'русский язык', value: 'ru' },
        { text: 'Français', value: 'fr' },
        { text: 'Español', value: 'es' },
        { text: 'Italiano', value: 'it' }
      ],
      lang: localStorage.getItem('lang') || 'zh',
      search: '',
      popshow: false,
      indexData: {
        notice: ['']
      },
      product: [],
      serverurl: '',
      user: {},
      suiji: false,
      editpass: {
        oldpass: '',
        newpass: '',
        newpass2: ''
      },
      msgcount: 0,
      notifyshow: false,
      websocket: null,
      wk: null
    }
  },
  created() {
    this.getdata()
    this.getmsgcount()
    // alert(this.lang)
  },
  mounted() {
    this.initwk()
  },
  methods: {
    // 获取未读信息数
    async getmsgcount() {
      const { data } = await this.$http.get('/home/home/msgcount')
      if (data) {
        if (data.code === 200) {
          this.msgcount = +data.data
          if (this.msgcount > 0) {
            this.notifyshow = true
            this.$refs.notify.play()
          }
        }
      }
    },
    // 获取首页数据
    async getdata() {
      const { data } = await this.$http.get('/home/home/index')
      if (data) {
        if (data.code === 200) {
          this.indexData = data.data
          this.product = data.data.product
          this.serverurl = data.data.serverurl
          this.user = data.data.user
          if (this.websocket === null) {
            this.initwebsocket()
          }
          if (data.data.user.random_password === '1') {
            this.suiji = true
          }
        }
      }
    },
    openside() {
      this.popshow = true
    },
    // 去教程
    tocourse() {
      this.$router.push('/course')
    },
    // 去理财页
    tofund() {
      this.$router.push('/fund')
    },
    // 去设置页
    tosetting() {
      this.$router.push('/person/setting')
    },
    // 客服链接
    toservice() {
      window.location.href = this.serverurl
    },
    // 去交易页
    totrade(id) {
      this.$router.push('/trade_' + id)
    },
    // 退出
    logout() {
      window.localStorage.removeItem('token')
      this.$router.push('/login')
    },
    async passsubmit() {
      if (
        !this.editpass.oldpass ||
        !this.editpass.newpass ||
        !this.editpass.newpass2
      ) {
        this.$toast.fail(this.$t('editpass.notice3'))
        return false
      }
      if (this.editpass.newpass !== this.editpass.newpass2) {
        this.$toast.fail(this.$t('editpass.eqpass'))
        return false
      }
      const { data } = await this.$http.post(
        '/home/home/editpass',
        this.editpass
      )
      if (data) {
        if (data.code === 200) {
          this.suiji = false
          this.getdata()
        } else {
          this.$toast.fail(this.getlang(data.msg, localStorage.getItem('lang')))
        }
      }
    },
    selectLangChange(value) {
      this.$i18n.locale = value
      localStorage.setItem('lang', value)
    },
    // 切换语言
    Language() {
      // function setCookie(cname, cvalue, exdays) {
      //   var d = new Date()
      //   d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
      //   var expires = 'expires=' + d.toUTCString()
      //   document.cookie = cname + '=' + cvalue + '; ' + expires
      // }
      // setCookie('googtrans', '', -1111111111111)
      setCookie('googtrans', '/auto/en', 100)
      if (this.$i18n.locale === 'zh') {
        this.$i18n.locale = 'en'
        localStorage.setItem('lang', 'en')
        // setCookie('googtrans', '/auto/en', 100)
      } else {
        this.$i18n.locale = 'zh'
        localStorage.setItem('lang', 'zh')
        // setCookie('googtrans', '/auto/zh', 100)
      }
      window.location.reload()
    },
    // 初始化连接
    initwebsocket() {
      this.websocket = new WebSocket(this.wsurl + '/wss:8880')
      this.websocket.onmessage = this.websocketonmessage
      this.websocket.onerror = this.websocketonerror
    },
    // 连接错误
    websocketonerror() {
      this.initwebsocket()
    },
    // 接收到数据
    websocketonmessage(e) {
      const message = JSON.parse(e.data)
      switch (message.type) {
        case 'init':
          this.binduid()
          break
        case 'text':
          this.getmsgcount()
          break
        case 'image':
          this.getmsgcount()
          break
      }
    },
    // 绑定uid
    binduid() {
      const msg = { type: 'bind', userid: this.user.id }
      this.websocketsend(JSON.stringify(msg))
    },
    // websorcket发送信息
    websocketsend(data) {
      this.websocket.send(data)
    },
    closenotify() {
      this.notifyshow = false
    },
    initwk() {
      this.wk = new WebSocket(this.wsurl + '/wssss:8080')
      this.wk.onmessage = this.wkonmessage
    },
    wkonmessage(e) {
      try {
        const data = JSON.parse(e.data)
        // console.log('行情:', data)
        // console.log(this.product)
        for (let key in data) {
          data[key].pid = this.product[key].pid
        }
        this.product = data
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.header {
  width: 100%;
  .van-search__content--round {
    height: 2rem;
  }
  /deep/.van-search {
    padding: 0;
  }
  /deep/.van-icon {
    color: #b2b2b2;
  }
  /deep/.van-nav-bar__right {
    font-size: 1.5rem;
  }
  .van-info {
    min-width: 18px;
    font-size: 14px;
  }
}
.maincontent {
  padding: 50px 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  font-size: 0.93333rem;
  // 轮播图
  .first-swipe {
    height: 10rem;
    .van-swipe-item img {
      width: 94%;
    }
  }
  .van-notice-bar {
    width: 94%;
    margin-left: 3%;
    background-color: #fff;
    color: #212121;
    border-radius: 5px;
  }
  //三个产品
  .currency-information {
    margin: 0.53333rem 0.8rem 0.53333rem 0.8rem;
    line-height: 2.66667rem;
    font-size: 0.93333rem;
    display: flex;
    white-space: nowrap;
    overflow-x: auto;
    .information {
      flex-shrink: 0;
      margin-right: 0.53333rem;
      width: 10.6rem;
      height: 4.26667rem;
      padding: 0.4rem;
      background-color: #fff;
      line-height: 1.6rem;
      border-radius: 0.26667rem;
    }
  }
  // 快捷买币
  .currency {
    width: 94%;
    margin-left: 3%;
    background-color: #fff;
    border-radius: 0.26667rem;
    overflow: hidden;
    .currency-shopping {
      background-color: #fff;
      color: #000;
      line-height: 1.46667rem;
      padding: 0.4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top-left-radius: 0.26667rem;
      border-top-right-radius: 0.26667rem;
      .currency-shopping-image {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .currency-shopping-left {
        font-size: 0.9333rem;
        text-align: left;
        padding-left: 0.8rem;
        span {
          font-size: 0.61333rem;
        }
      }
    }
    .currency-service-span {
      border-bottom-left-radius: 0.26667rem;
      border-bottom-right-radius: 0.26667rem;

      div {
        padding: 0.4rem;
        background-color: #fff;
        display: flex;
        align-items: center;
        text-align: left;
        .van-image {
          padding: 0;
        }
        .van-col {
          float: left;
          box-sizing: border-box;
          min-height: 1px;
        }
        span {
          font-size: 0.8rem;
          margin-left: 0.53333rem;
        }
      }
    }
  }
  // banner
  .banner-image {
    width: 94%;
    margin: 0.53333rem 3%;
    .van-image {
      position: relative;
      display: inline-block;
    }
    /deep/.van-image__img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 0.53333rem !important;
    }
  }
  // 产品列表
  .currency-title {
    margin-top: 0.8rem;
    margin-bottom: 0.4rem;
    font-size: 0.8rem;
    color: #b2b2b2;
  }
  .currency-Increase {
    background-color: #fff;
    padding-top: 0.8rem;
    padding-bottom: 0.8rem;
    font-size: 1.12rem;
    height: 3.46667rem;
    border-bottom: 0.02667rem solid #e5e5e5;
    display: flex;
    align-items: center;
    .currency-btn {
      border: none;
      border-radius: 0.26667rem;
      width: 6.4rem;
      height: 2.13333rem;
      color: #fff;
      font-size: 1.12rem;
    }
  }
}
// 弹出层
.personage-head {
  height: 18%;
  display: flex;
  align-items: center;
  justify-content: center;
  .personage-head-image {
    margin-right: 5%;
  }
  .personage-head-span {
    text-align: left;
    font-size: 1.33333rem;
    line-height: 2.13333rem;
  }
}
.personage-member {
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  .personage-member-a {
    height: 100%;
    width: 90%;
    padding: 0 5%;
    border-top-left-radius: 0.26667rem;
    border-top-right-radius: 0.26667rem;
    background-color: #e9c455;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .van-col {
    float: left;
    box-sizing: border-box;
    min-height: 1px;
  }
}
// 列表区域
.van-cell {
  font-size: 1.06667rem;
  color: #000 !important;
  height: 3.2rem;
  letter-spacing: 0.26667rem;
}
.van-popup .van-icon {
  font-size: 1.2rem;
}
.van-cell__title {
  text-align: left;
  margin-left: 0.4rem;
}
// 切换语言
.personage-cut {
  width: 100%;
  position: fixed;
  bottom: 4rem;
  background-color: #f7f7f7;
  height: 2.66667rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.98667rem;
  color: #004ea3;
}
// 退出登录
.personage-button {
  width: 100%;
  position: fixed;
  bottom: 0.63333rem;
  b {
    font-size: 1.6rem;
    letter-spacing: 0.48rem;
  }
}
</style>
